// extracted by mini-css-extract-plugin
export default {"call":"audioCall_call__rPIjI","call_title":"audioCall_call_title__R1mZm","play_call":"audioCall_play_call__L488K","btn_start_call":"audioCall_btn_start_call__rlNwI"};